import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { GROWTHBOOK_FEATURE_FLAGS } from '@web-app/constants/growthbook';
import { useRouter } from 'next/router';

/**
 * Hook to determine if the MFA phone number prompt should be enabled.
 *
 * Priority (highest to lowest):
 * 1. URL query parameter ?mfaPhonePrompt=true|false (always overrides)
 * 2. GrowthBook feature flag 'mfa-phone-prompt'
 */
export const useMfaPhonePromptEnabled = (): boolean => {
  const router = useRouter();
  const growthBookEnabled = useFeatureIsOn(
    GROWTHBOOK_FEATURE_FLAGS.MFA_PHONE_PROMPT,
  );

  const queryParam = router.query['mfaPhonePrompt'];
  if (queryParam === 'true') {
    return true;
  }
  if (queryParam === 'false') {
    return false;
  }

  return growthBookEnabled;
};
